import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { notificationApi } from '../lib/api'

/**
 * Poll for unread notification count (every 60 seconds).
 */
export function useUnreadNotificationCount() {
  return useQuery({
    queryKey: ['notifications-unread-count'],
    queryFn: notificationApi.unreadCount,
    refetchInterval: 60 * 1000,
    staleTime: 30 * 1000,
  })
}

/**
 * Fetch recent notifications.
 */
export function useNotifications(enabled: boolean) {
  return useQuery({
    queryKey: ['notifications'],
    queryFn: notificationApi.list,
    enabled,
  })
}

/**
 * Mark all notifications as read.
 */
export function useMarkAllRead() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: notificationApi.markAllRead,
    onSuccess: () => {
      queryClient.setQueryData(['notifications-unread-count'], { count: 0 })
      queryClient.invalidateQueries({ queryKey: ['notifications'] })
    },
  })
}
